import NextLink from "common/bit/NextLink"
import { StyledSvgIcon } from "theme/shared"

type SocialIconButtonProps = {
  iconName: string
  link: string
  alt?: string
}

const SocialIconButton = ({ link, iconName, alt }: SocialIconButtonProps) => {
  return (
    <>
      {link && (
        <NextLink href={link} passHref openInNewTab>
          <StyledSvgIcon
            src={`/icons/${iconName}.svg`}
            alt={alt ? alt : "icon-button"}
            w={20}
            h={20}
          />
        </NextLink>
      )}
    </>
  )
}

export default SocialIconButton
